import PropTypes from "prop-types";
import { useEffect, useState, useContext } from "react";
import { Button, Card, Col, Collapse, Row } from "reactstrap";
import SelectController from "../../../../../core/ui/components/SelectController";

import { toast } from "../../../../../core/helpers/message-helper";
import { selectSedes } from "../../../../Sedes/services/sedes-service";

import { API_DOMAIN } from "../../../../../core/config/env";
import SubAreasContext from "../../../store/sub-areas-context";
import {
    obtenerSubAreasPorSede,
    obtenerSubAreasPorSedesYPersona,
} from "../../../../../core/services/areas-service";

import "./estilos.css";
import useUser from "../../../../../core/hooks/use-user";

const ListaSedes = ({ sedes }) => {
    const [managerLista, setManagerLista] = useState({});

    useEffect(() => {
        const manager = {};
        sedes.forEach((sede) => (manager[sede.sede_id] = false));
        setManagerLista(manager);
    }, [sedes]);

    const toggleItemSede = (idSede, valor) => {
        setManagerLista((prev) => {
            const manager = { ...prev };

            for (const key in manager) {
                if (!Object.hasOwnProperty.call(manager, key)) continue;
                if (key != idSede) manager[key] = false;
                else manager[key] = valor;
            }

            return manager;
        });
    };

    return sedes.map((sedeArea) => {
        return (
            <SedeCollapseItem
                sede={sedeArea}
                key={sedeArea.sede_id}
                toggleItemSede={toggleItemSede}
                abierto={managerLista[sedeArea.sede_id]}
            />
        );
    });
};

const ListaSubAreasAgregadas = () => {
    const { personaHasSubAreas, eliminarSubArea } = useContext(SubAreasContext);

    const listaSubAreas = [
        ...personaHasSubAreas.get("nuevas").entries(),
        ...personaHasSubAreas.get("actuales").entries(),
    ];

    return listaSubAreas.map(([key, personaHSA]) => {
        return (
            <div key={key} className="mb-1">
                <h6 className="d-inline">
                    <i className="fas fa-building mr-3"></i>
                    {personaHSA.sub_area_nombre} ({personaHSA.sede_nombre})
                </h6>
                <div
                    title="Eliminar sub área"
                    className="sub-areas-action d-inline-block ml-3 rounded-circle bg-danger text-center"
                    onClick={() => eliminarSubArea(key)}
                >
                    <i className="fas fa-times"></i>
                </div>
            </div>
        );
    });
};

const ListaSubAreasAAgregar = ({ subAreas, area, sede_nombre, sede_id }) => {
    const { agregarSubArea } = useContext(SubAreasContext);

    return subAreas.map((subArea) => {
        return (
            <li className="mb-1" key={`${sede_id}-${subArea.sub_area_id}`}>
                <div>
                    <i className="fas fa-building mr-3"></i>
                    {subArea.sub_area_nombre}
                    <div
                        title="Agregar sub área"
                        className="sub-areas-action d-inline-block ml-3 rounded-circle bg-primary text-center"
                        onClick={() => {
                            agregarSubArea({
                                ...subArea,
                                area_id: area.id,
                                sede_id: sede_id,
                                sede_nombre: sede_nombre,
                                area_nombre: area.nombre,
                            });
                        }}
                    >
                        <i className="fas fa-plus"></i>
                    </div>
                </div>
            </li>
        );
    });
};

const ListaAreas = ({ areas = [], sede_id, sede_nombre }) => {
    return areas.map((area) => {
        return (
            <div className="pl-4" key={`${sede_id}-${area.id}`}>
                <hr />
                <h6>{area.nombre}</h6>
                <div>
                    <ul style={{ listStyle: "none" }}>
                        <ListaSubAreasAAgregar
                            subAreas={area.sub_areas}
                            area={area}
                            sede_id={sede_id}
                            sede_nombre={sede_nombre}
                        />
                    </ul>
                </div>
            </div>
        );
    });
};

const SedeCollapseItem = ({ sede, abierto = false, toggleItemSede }) => {
    const toggleOpen = (e) => {
        e.stopPropagation();
        toggleItemSede(sede.sede_id, !abierto);
    };

    const colStyle = {
        maxHeight: "250px",
        overflow: "auto",
    };

    return (
        <Row className="pl-2">
            <Col md={10} style={colStyle}>
                <Card className="py-1">
                    <div>
                        <img
                            src={`${API_DOMAIN}${sede.sede_img}`}
                            className="rounded-circle mr-2"
                            width="40px"
                            height="40px"
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = "img/logo_csr_big.png";
                            }}
                        />
                        <h4 onClick={toggleOpen} className="sede-card d-inline">
                            {sede.sede_nombre}
                        </h4>
                    </div>
                    <Collapse isOpen={abierto}>
                        <ListaAreas
                            areas={sede.areas}
                            sede_id={sede.sede_id}
                            sede_nombre={sede.sede_nombre}
                        />
                    </Collapse>
                </Card>
            </Col>
            <Col md={2}>
                <p onClick={toggleOpen}>
                    <i
                        style={{ fontSize: "20px" }}
                        className={`fas ${
                            abierto ? "fa-angle-up" : "fa-angle-down"
                        }`}
                    ></i>
                </p>
            </Col>
        </Row>
    );
};

SedeCollapseItem.propTypes = {
    sede: PropTypes.object,
    abierto: PropTypes.bool,
    toggleItemSede: PropTypes.func,
};

const AreasTab = ({ errors, control, getValues, tipo }) => {
    const [sedes, setSedes] = useState([]);
    const [buscandoAreas, setBuscandoAreas] = useState(false);
    const [sedesAreas, setSedesAreas] = useState([]);
    const usuario = useUser();

    useEffect(async () => {
        if (tipo == "areasEditar") {
            const sedesAreasLider = usuario.getUserData().sedes_areas;
            const clavesSede = sedesAreasLider.map((sede) => sede.sede);
            setSedes(
                clavesSede.map((sede) => {
                    return { label: sede.nombre, value: sede.id };
                })
            );
        } else {
            const resp = await selectSedes({ status: 1 });
            if (!resp.status) return toast.error(resp.message);
            setSedes(
                resp.data.map((sede) => {
                    return { label: sede.sigla, value: sede.id, ...sede };
                })
            );
        }
    }, []);

    const buscarAreas = async () => {
        let sedes = getValues("sedes");
        sedes = sedes.map((sede) => sede.value);
        if (tipo == "areasEditar") {
            setBuscandoAreas(true);
            const resp = await obtenerSubAreasPorSedesYPersona(
                sedes,
                usuario.getUserData().id
            );
            setBuscandoAreas(false);
            if (!resp.status) return toast.error(resp.message);
            setSedesAreas(resp.data);
        } else {
            setBuscandoAreas(true);
            const resp = await obtenerSubAreasPorSede(sedes);
            setBuscandoAreas(false);
            if (!resp.status) return toast.error(resp.message);
            setSedesAreas(resp.data);
        }
    };

    return (
        <Row className="mb-4">
            <Col md={9}>
                <SelectController
                    name="sedes"
                    isMulti={true}
                    options={sedes ?? []}
                    control={control}
                    errors={errors}
                    label="Selecciona una sede"
                />
            </Col>
            <Col
                md="3"
                className="d-flex justify-content-center align-items-center"
            >
                <Button onClick={buscarAreas}>
                    <i className="fas fa-search mr-2"></i>
                    Buscar áreas por estas sedes
                </Button>
            </Col>
            <Col md={6} className="mt-3">
                <h4 className="text-center">Áreas a agregar</h4>
                {buscandoAreas ? (
                    <p>Cargando areas...</p>
                ) : (
                    <ListaSedes sedes={sedesAreas} />
                )}
            </Col>
            <Col md={6} className="mt-3">
                <h4 className="text-center">Sub Áreas agregadas</h4>
                <Card className="p-2">
                    <ListaSubAreasAgregadas />
                </Card>
            </Col>
        </Row>
    );
};

AreasTab.propTypes = {
    errors: PropTypes.object,
    control: PropTypes.object,
    getValues: PropTypes.func,
    tipo: PropTypes.string,
};

export default AreasTab;
